"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PopupModalTypes = exports.PopupModalComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _siblingSet = _interopRequireDefault(require("@ux/sibling-set"));
require("@ux/sibling-set/styles");
var _button = _interopRequireDefault(require("@ux/button"));
var _modal = _interopRequireDefault(require("@ux/modal"));
var _storeProvider = require("./../util/storeProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PopupModalTypes = exports.PopupModalTypes = {
  MODAL_TYPE_NONE: 'none',
  MODAL_TYPE_BASIC: 'Basic',
  MODAL_TYPE_CONFIRMATION: 'Confirmation'
};
class PopupModalComponent extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalShown: false
    };
    this.confirm = this.confirm.bind(this);
    this.close = this.close.bind(this);
    this.modal = this.modal.bind(this);
  }
  confirm(e) {
    const {
      confirmFunc = null
    } = this.props;
    if (confirmFunc) {
      this.setState({
        modalShown: true
      }, () => confirmFunc(e));
    }
    this.close(e);
  }
  close(e) {
    const {
      cancelFunc
    } = this.props;
    if (cancelFunc) {
      cancelFunc(e);
    } else {
      this.setState({
        modalShown: true
      });
    }
  }
  modal() {
    const {
      title,
      text,
      cancelText = '',
      confirmText = '',
      show,
      type = PopupModalTypes.MODAL_TYPE_BASIC
    } = this.props;
    const showModal = show && !this.state.modalShown;
    if (!showModal) {
      return null;
    }
    const footer = /*#__PURE__*/React.createElement(_siblingSet.default, null, /*#__PURE__*/React.createElement(_button.default, {
      design: "primary",
      onClick: e => {
        this.confirm(e);
      },
      text: confirmText
    }), /*#__PURE__*/React.createElement(_button.default, {
      design: "secondary",
      onClick: e => {
        this.close(e);
      },
      text: cancelText
    }));
    return /*#__PURE__*/React.createElement(_modal.default, {
      title: title,
      onClose: e => {
        this.close(e);
      },
      footer: type === PopupModalTypes.MODAL_TYPE_CONFIRMATION ? footer : null
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: `${text}`
      }
    }));
  }
  render() {
    return /*#__PURE__*/React.createElement(_react.Fragment, null, this.modal());
  }
}
exports.PopupModalComponent = PopupModalComponent;
PopupModalComponent.propTypes = {
  cancelFunc: _propTypes.default.func,
  confirmFunc: _propTypes.default.func,
  title: _propTypes.default.string.isRequired,
  text: _propTypes.default.string.isRequired,
  cancelText: _propTypes.default.string,
  confirmText: _propTypes.default.string,
  type: _propTypes.default.string,
  show: _propTypes.default.bool.isRequired
};
var _default = exports.default = (0, _storeProvider.provideContext)(PopupModalComponent);